import { connect } from 'react-redux';
import React from 'react';

import PropTypes from 'prop-types';

import Helmet from 'wanderu-component-helmet';
import { localize, selectLocale } from 'wanderu-i18n';

import placeGuideConfig from '../../../../config/placeguide.locale';

function PlaceGuideMeta(props) {
    const {
        t,
        data,
        i18nMoney,
        locale,
        noIndex,
        noIndexLocale,
        ...otherProps
    } = props;

    const description = t('metaPageDescription');
    const title = data && data.cheapestAvgPrice
        ? t('metaPageTitle', {
            avgPrice: i18nMoney(Math.round(data.cheapestAvgPrice)).format({
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            }),
        })
        : t('metaPageTitle');

    const supportedLocales = () => {
        return placeGuideConfig.supportedLocales
            .filter((locale) => !noIndexLocale?.includes(locale) ?? false);
    };

    const isNoIndex = () => {
        const isIndexable = !noIndex && (!noIndexLocale?.includes(locale) ?? true);
        return !isIndexable;
    };

    return (
        <Helmet
            {...otherProps}
            description={description}
            noIndex={isNoIndex()}
            supportedLocales={supportedLocales()}
            title={title}
        />
    );
}

PlaceGuideMeta.propTypes = {
    data: PropTypes.object,
    canonicalPath: PropTypes.string.isRequired,
    noIndex: PropTypes.bool,
    structuredData: PropTypes.arrayOf(PropTypes.object),
};
PlaceGuideMeta.defaultProps = {
    data: {},
    structuredData: [],
    noIndex: false,
    noIndexLocale: []
};

function mapStateToProps(state) {
    return {
        locale: selectLocale(state),
    };
}

export {
    PlaceGuideMeta,
};

export default connect(mapStateToProps)(
    localize(PlaceGuideMeta, ['i18nMoney', 't'], placeGuideConfig.namespace)
);
